<section>
  <form class="d-flex flex-row justify-content-end" [formGroup]="form">
    <div
      role="button"
      class="search-bar-wrapper user-select-none border-border"
      [class.collapsed]="inputFieldHidden && !showInputField"
      (click)="onWrapperClick()"
    >
      <span class="search-icon">
        <tr-icon [icon]="icon.search" [color]="iconColor.blue"></tr-icon>
      </span>

      <input
        #query
        type="text"
        class="search-input"
        [placeholder]="placeholder"
        *ngIf="displayInputField"
        formControlName="searchString"
        (input)="newSearch(query.value)"
      >

      <button
        *ngIf="displayInputField"
        [style.opacity]="searchStringLength === 0 ? 0 : 1"
        class="clear-btn"
        type="button"
        (click)="clearSearchField(); $event.stopPropagation()"
      >
        <tr-icon [icon]="icon.cancel" [color]="iconColor.blue"></tr-icon>
      </button>
    </div>

    <div
      class="error user-select-none"
      *ngIf="searchStringLength > 0 && searchStringLength < minQueryLength && form.touched"
    >
      Query should have {{ minQueryLength }} or more characters
    </div>
  </form>
</section>
